import { z } from 'zod';
import { decisionSchemaSchema as baseDecisionSchemaSchema } from '@xiltrion/decisiones/contract';
import { codeSchema } from '../code.js';
import { JUDICIAL_INTAKE_SCHEMA_CODE } from '../judicial/judicial.js';
/**
 * A DecisionSchema tells an engine WHAT to decide (fields + allowed values). Versioned per tenant. The engine output
 * is validated against it. The field and schema shapes are the suite's (`@xiltrion/decisiones/contract`); for «type»,
 * «area» and «specialty» the options are the codes of those catalogs (e.g. "SALUD_ASEGURAMIENTO").
 */
/**
 * System schema: the one the triage always classifies with. Maintained by the platform (seed), never edited by
 * tenants; its «type» and «specialty» options follow the active case types and specialties of the tenant.
 */
export const SYSTEM_DECISION_SCHEMA_CODE = 'CLASSIFICATION_V1';
/**
 * Esquema del sistema con el que el correo entrante se filtra antes de radicar: ¿este correo es una solicitud de
 * alguien hacia la entidad, o un boletín, un aviso automático o correspondencia de trabajo?
 */
export const EMAIL_INTAKE_SCHEMA_CODE = 'EMAIL_INTAKE_V1';
/** Esquemas de la plataforma: se listan como «del sistema» y no se editan. */
/** Esquemas de la plataforma (triaje, filtro del correo, lectura del auto judicial): se listan como «del sistema» y no se editan. */
export const SYSTEM_DECISION_SCHEMA_CODES = [SYSTEM_DECISION_SCHEMA_CODE, EMAIL_INTAKE_SCHEMA_CODE, JUDICIAL_INTAKE_SCHEMA_CODE];
export const EMAIL_INTAKE_FIELD = 'kind';
/** `REQUERIMIENTO_JUDICIAL`: un juzgado notifica una tutela; se radica siempre y el triaje le pone el tipo. */
export const EmailIntakeKind = { SOLICITUD: 'SOLICITUD', REQUERIMIENTO_JUDICIAL: 'REQUERIMIENTO_JUDICIAL', BOLETIN: 'BOLETIN', AVISO_AUTOMATICO: 'AVISO_AUTOMATICO', CORRESPONDENCIA: 'CORRESPONDENCIA' };
export const EMAIL_INTAKE_KIND_LABEL = { SOLICITUD: 'Solicitud de un ciudadano', REQUERIMIENTO_JUDICIAL: 'Requerimiento judicial', BOLETIN: 'Boletín o promoción', AVISO_AUTOMATICO: 'Aviso automático', CORRESPONDENCIA: 'Correspondencia de trabajo' };
/** Lo que llegó al buzón se radica como caso: una solicitud o un requerimiento de un juzgado. */
export const EMAIL_INTAKE_FILED_KINDS = [EmailIntakeKind.SOLICITUD, EmailIntakeKind.REQUERIMIENTO_JUDICIAL];
/** The suite's schema with PQRS's code rules (UPPER_SNAKE, `codeSchema`). */
export const decisionSchemaSchema = baseDecisionSchemaSchema.extend({ code: codeSchema(60) });
/** Canonical field names used by the workflow/assignment engines. Tenants may add more. */
export const CanonicalDecisionField = {
    TYPE: 'type',
    INTENT: 'intent',
    TOPIC: 'topic',
    AREA: 'area',
    SPECIALTY: 'specialty',
    PRIORITY: 'priority',
    POSSIBLE_DUPLICATE: 'possibleDuplicate',
};
export const decisionResultSchema = z.object({
    engine: z.string().min(1),
    engineVersion: z.string().min(1),
    decisions: z.array(z.object({
        field: z.string().min(1),
        value: z.unknown(),
        confidence: z.number().min(0).max(1).optional(),
        evidence: z.array(z.string()).optional(),
    })),
    confidence: z.number().min(0).max(1).optional(),
    requiresHumanReview: z.boolean(),
    processingTimeMs: z.number().nonnegative(),
    inputHash: z.string().min(1),
    reasoning: z.unknown().optional(),
});
export const overrideDecisionSchema = z.object({
    field: z.string().min(1),
    newValue: z.unknown(),
    reasonCode: z.enum(['INCORRECT', 'ADDITIONAL_INFO', 'ORG_RULE', 'OTHER']),
    comment: z.string().max(2000).optional(),
});
//# sourceMappingURL=schema.js.map